<template>
  <v-app :class="mersBranded ? 'mers' : 'alerus'">
    <v-toolbar app :color="appHeaderColor">
      <v-toolbar-title v-if="mersBranded">
        <router-link to="/">
          <v-img :src="require('@/assets/imgs/MERS-Green-Black.png')" width="150px" />
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title v-else>
        <router-link to="/">
          <v-img :src="require('@/assets/imgs/alerus-dark.svg')" width="150px" />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="user">
        <v-btn to="/" flat :color="appButtonColor">Dashboard</v-btn>
        <v-btn
          v-if="adminOrSuper"
          @click="setSponsor(true)"
          flat
          :color="appButtonColor"
        >New Sponsor</v-btn>
        <v-btn
          v-if="userGroup === 'Super' || userGroup === 'SystemAdmin'"
          to="/manage"
          flat
          :color="appButtonColor"
        >Manage</v-btn>
        <v-btn v-if="userGroup === 'SystemAdmin'" to="/config" flat :color="appButtonColor">Config</v-btn>
        <v-btn
          v-if="userGroup === 'SystemAdmin'"
          to="/restricted"
          flat
          :color="appButtonColor"
        >Restricted</v-btn>
        <v-btn
          v-if="userGroup === 'SystemAdmin'"
          to="/whitelist"
          flat
          :color="appButtonColor"
        >Whitelist</v-btn>
        <v-btn
          v-if="userGroup === 'SystemAdmin'"
          to="/logs"
          flat
          :color="appButtonColor"
        >Logs</v-btn>
        <v-btn @click="logout" flat :color="appButtonColor">Sign Out</v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-else>
        <v-btn @click="login" flat :color="appButtonColor">Sign In</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <sponsor v-model="sponsor" />
        <restricted-user v-model="restrictedModal" />
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import Sponsor from "@/components/Sponsor";
import RestrictedUser from "@/components/RestrictedUser";
import "@/assets/fonts/fonts.css";
export default {
  name: "App",
  components: {
    Sponsor,
    RestrictedUser,
  },
  data() {
    return {
      //
    };
  },
  async created() {},
  computed: {
    ...mapState("user", ["confirmed", "user", "state", "mersBranded"]),
    ...mapState("accounts", ["sponsor", "restrictedModal"]),
    ...mapGetters("user", ["isAuthenticated", "userGroup", "adminOrSuper"]),
    appHeaderColor() {
      return this.mersBranded ? "#F1F1F1" : "#E9E6E1";
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
  },
  methods: {
    ...mapMutations("user", ["emptyUser", "unsetConfirmed", "setState"]),
    ...mapMutations("accounts", ["setPage", "emptyUserAccount", "setSponsor"]),
    ...mapActions("user", ["login"]),
    logout() {
      localStorage.clear();
      this.emptyUserAccount();
      this.emptyUser();
      this.unsetConfirmed();
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}
body {
  //font-family: "Poppins";
  .alerus {
    font-family: "the-serif";
  }
  .mers {
    font-family: "Ubuntu";
    // font-size: 120%;
    .v-btn__content {
      font-size: 1.1rem;
    }
    .active::before {
      background-color: #33715a;
    }
  }
  margin: 0;
  height: 100%;
}
#app {
  //height: 100%;
}
.active {
  background-color: #d9d7d7;
}
</style>

